import SectionMessage from '@atlaskit/section-message';
import React from 'react';
import { FormattedMessage } from 'react-intl';

export const BitbucketActionMessage = ({ accountName }: { accountName: string }) => (
  <SectionMessage>
    <FormattedMessage
      id="mac.licenses.bitbucket-change"
      defaultMessage="You can make changes to your subscription"
    />{' '}
    <a
      href={`https://bitbucket.org/${accountName}/workspace/settings/plans/`}
      target="_blank"
      rel="noopener noreferrer"
    >
      <FormattedMessage id="mac.licenses.bitbucket-change.link" defaultMessage="here" />
    </a>
  </SectionMessage>
);
